import React from 'react';
import Link from 'next/link';
import AppLogo from '@/components/ui/AppLogo';
import { MapPin, Phone, Mail, ExternalLink } from 'lucide-react';

export default function PublicFooter() {
  return (
    <footer className="bg-[#111e3d] text-white mt-16">
      {/* Gold accent bar */}
      <div className="h-1 bg-gradient-to-r from-[#c9a84c] via-[#e0be72] to-[#c9a84c]" />
      <div className="max-w-screen-2xl mx-auto px-6 xl:px-10 2xl:px-16 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <AppLogo size={36} />
              <div>
                <div className="text-white font-700 text-base">Philips University</div>
                <div className="text-[#c9a84c] text-xs font-500">Thesis Repository</div>
              </div>
            </div>
            <p className="text-white/50 text-sm leading-relaxed mb-4 max-w-sm">
              Philips Library is a member of the Cyprus Academic Libraries Association (CAIC) and the Consortium of Cyprus Academic Libraries (CCAL). Open access to academic research from Cyprus.
            </p>
            <div className="space-y-2">
              <div className="flex items-center gap-2 text-white/50 text-sm">
                <MapPin size={13} className="text-[#c9a84c] flex-shrink-0" />
                4-6 Lamias Street, 2001 Nicosia, Cyprus
              </div>
              <div className="flex items-center gap-2 text-white/50 text-sm">
                <Phone size={13} className="text-[#c9a84c] flex-shrink-0" />
                <a href="tel:+35722441860" className="hover:text-white transition-colors">+357 22 441860</a>
              </div>
              <div className="flex items-center gap-2 text-white/50 text-sm">
                <Mail size={13} className="text-[#c9a84c] flex-shrink-0" />
                <a href="mailto:library@philipsuni.ac.cy" className="hover:text-white transition-colors">library@philipsuni.ac.cy</a>
              </div>
            </div>
          </div>

          {/* Repository */}
          <div>
            <h4 className="text-white font-600 text-sm mb-4 uppercase tracking-wide">Repository</h4>
            <ul className="space-y-2">
              {[
                { href: '/public-thesis-portal', label: 'Browse All Theses' },
                { href: '/public-thesis-portal', label: "Master's Theses" },
                { href: '/public-thesis-portal', label: 'PhD Dissertations' },
                { href: '/public-thesis-portal', label: 'Open Access Works' },
                { href: '/public-thesis-portal', label: 'Recent Submissions' },
              ]?.map((item) => (
                <li key={`footer-repo-${item?.label}`}>
                  <Link href={item?.href} className="text-white/50 hover:text-[#c9a84c] text-sm transition-colors">{item?.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Internal */}
          <div>
            <h4 className="text-white font-600 text-sm mb-4 uppercase tracking-wide">Internal Portal</h4>
            <ul className="space-y-2">
              {[
                { href: '/student-submission-portal', label: 'Student Login' },
                { href: '/student-submission-portal', label: 'Submit Thesis' },
                { href: '/admin-management-panel', label: 'Admin Panel' },
                { href: 'https://philipsuni.ac.cy', label: 'University Website', external: true },
                { href: 'https://philipsuni.ac.cy/library', label: 'Library Services', external: true },
              ]?.map((item) => (
                <li key={`footer-int-${item?.label}`}>
                  {'external' in item && item?.external ? (
                    <a
                      href={item?.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-white/50 hover:text-[#c9a84c] text-sm transition-colors flex items-center gap-1"
                    >
                      {item?.label}
                      <ExternalLink size={10} />
                    </a>
                  ) : (
                    <Link href={item?.href} className="text-white/50 hover:text-[#c9a84c] text-sm transition-colors">{item?.label}</Link>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-white/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-white/35 text-xs">
            © 2026 Philips University Cyprus. All rights reserved. | Πανεπιστήμιο Φίλιππος Κύπρου
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-white/35 hover:text-white/60 text-xs transition-colors">Privacy Policy</a>
            <a href="#" className="text-white/35 hover:text-white/60 text-xs transition-colors">Terms of Use</a>
            <a href="#" className="text-white/35 hover:text-white/60 text-xs transition-colors">Accessibility</a>
          </div>
        </div>
      </div>
    </footer>
  );
}